import { useEffect } from "react";
import { Wishlist } from "../../constants";
import { useAppDispatch } from "../../reduxToolkit/hooks";
import { fetchProductApiData } from "../../reduxToolkit/reducers/productSlice";
import { routes } from "../../routers/routes";
import Breadcrumbs from "../commonComponents/breadcrumbs";
import WishlistBox from "../commonComponents/WishlistBox";

const PropertyWishlistContainer = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchProductApiData());
  }, [dispatch]);
  return (
    <>
      <Breadcrumbs title={Wishlist} url={routes.Home.PropertyDemo1} />
      <WishlistBox type="property" />
    </>
  );
};

export default PropertyWishlistContainer;
